module.exports = __webpack_public_path__ + "static/media/correct.76de6917.svg";